import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Login from './Login';
import Password from './Password';
import { Box } from '@mui/material';
import { validateUser } from '../../api';

import validator from "validator";
import { setAuthUsername } from '../../service/actions/index';
import { setSnackDetails, setMetaData } from '../../service/actions/common';
const Auth = () => {
    const dispatch = useDispatch();
    const username = useSelector((state) => state.username);
    const [isLogin, setIsLogin] = useState(true);
    const metaData  = {
      title: 'Sign In | InspectReply AI',
      description: 'Sign In | InspectReply AI'
    };
    useEffect(() => {
      dispatch(setMetaData(metaData));
      // eslint-disable-next-line
    }, []);    
	
    const switchToPassword = async () => {
        // Validate email
        if (username === '') {
          dispatch(setSnackDetails({openState : true, message : "*Email is required to login", severity : 'error'}));
          return;
        }
        if (! validator.isEmail(username) ) {
          dispatch(setSnackDetails({openState : true, message : "*Please type in a valid email", severity : 'error'}));
          return;
        }
        try {
          await validateUser({ username });
          setIsLogin(false);
          return false;
        } catch (error) {
            if (error.response) {
                if (error.response.status === 400) {
                    dispatch(setSnackDetails({openState : true, message : error.response.data.message, severity : 'error'}));
                    return false;
                } else {
                  dispatch(setSnackDetails({openState : true, message : 'Server Error', severity : 'error'}));
                }
            } else if (error.request) {
              dispatch(setSnackDetails({openState : true, message : 'Connection Lost', severity : 'error'}));
            } else {
              dispatch(setSnackDetails({openState : true, message : 'An unknown error occurred.', severity : 'error'}));
            }
        }
        return false;
    };
    const switchToLogin = () => {
        dispatch(setAuthUsername(''));
        setIsLogin(true);
    };

  return (
      <Box>
          {isLogin ? (
            <Login switchToPassword={switchToPassword} />
          ) : (
            <Password switchToLogin={switchToLogin} />
          )}
      </Box>
  );
};

export default Auth;
